import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './faq.scss';

const faqs = [
  {
    question: 'Como funciona o autoatendimento?',
    answer: 'É muito simples! Você coloca suas roupas na máquina, escolhe o programa desejado (lavagem ou secagem), efetua o pagamento e pronto. A máquina faz todo o trabalho. Nossos produtos premium (Omo e Comfort) já estão inclusos. A secagem leva apenas 45 minutos.'
  },
  {
    question: 'Preciso trazer sabão e amaciante?',
    answer: 'Não! Todas as nossas máquinas já utilizam produtos premium como Omo e Comfort automaticamente. Você não precisa trazer nada, apenas suas roupas.'
  },
  {
    question: 'Qual a capacidade das máquinas?',
    answer: 'Nossas máquinas comportam até 10kg de roupas, ideal para famílias ou grandes volumes. Isso equivale a aproximadamente 40-50 peças de roupa.'
  },
  {
    question: 'Quais formas de pagamento são aceitas?',
    answer: 'Aceitamos PIX, cartão de crédito e cartão de débito para sua comodidade. O pagamento é feito diretamente nas máquinas ou no balcão.'
  },
  {
    question: 'Quanto tempo leva a lavagem e secagem?',
    answer: 'A lavagem completa leva cerca de 30-40 minutos, dependendo do programa escolhido. A secagem é super rápida: apenas 45 minutos! Você pode fazer tudo em aproximadamente 1h30.'
  },
  {
    question: 'Posso deixar minhas roupas para o serviço completo?',
    answer: 'Sim! Oferecemos serviço completo onde lavamos, secamos e dobramos suas roupas com todo cuidado. Os valores variam conforme o volume e tipo de peça. Entre em contato para orçamento.'
  },
  {
    question: 'Vocês lavam edredons e cobertores?',
    answer: 'Sim! Temos máquinas especiais para peças grandes como edredons, cobertores e cortinas. Fazemos a lavagem profissional com produtos adequados. Consulte valores pelo WhatsApp.'
  },
  {
    question: 'Posso esperar no local enquanto lavo minhas roupas?',
    answer: 'Claro! Temos uma área de espera confortável com Wi-Fi grátis, ar-condicionado e assentos. Você pode trabalhar, estudar ou relaxar enquanto aguarda.'
  }
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq">
      <div className="container">
        <motion.div 
          className="faq-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title">Perguntas Frequentes</h2>
          <p className="section-subtitle">Tire suas dúvidas sobre nossos serviços</p>
        </motion.div>

        <div className="faq-list">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              className="faq-item"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.05 }}
            >
              <button
                className={`faq-question ${openIndex === index ? 'active' : ''}`}
                onClick={() => toggleFAQ(index)}
              >
                <span>{faq.question}</span>
                <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line`}></i>
              </button>
              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    className="faq-answer"
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <p>{faq.answer}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}